<style lang="less">
    .gantt_dialog {
        width: 340px;
    }

    .border-wrap {
        overflow-y: auto;
        padding: 16px;
        display: flex;
        flex-direction: column;
        border: 1px solid var(--border-color-box-6);
        border-radius: 6px;
    }

    .GanttSet-input {
        margin-left: 12px !important;
    }

    .select_columnbox {
        label {
            height: 16px;
            margin: 0;
        }
        .ivu-checkbox {
            margin-right: 5px;
            &:not(.ivu-checkbox-checked) {
                .ivu-checkbox-inner {
                    background-color: var(--bg-color-tertiary);
                }
            }
        }

        .border-wrap {
            .ivu-input-number-handler-wrap,
            .ivu-input-number-input {
                background-color: var(--bg-color-tertiary);
            }
            > div + div {
                margin-top: 16px;
            }
        }
    }
</style>

<template>
    <Dialog class="gantt_dialog" :title="$t('title')" :isShow="true" :mask="true" :showFooter="true" @ok="ok">
        <div class="select_columnbox">
            <div class="border-wrap">
                <div v-for="item in checkList.slice(0, 2)">
                    <Checkbox :label="item.value" @on-change="onCheckBoxChange($event, item.value)" :value="item.isCheck">
                        {{ $t(item.value) }}
                    </Checkbox>
                    <InputNumber v-show="item.isCheck" class="GanttSet-input" size="small" :min="1" :max="5" v-model="item.num"></InputNumber>
                </div>
            </div>
            <div class="border-wrap" style="margin-top: 16px; margin-bottom: 24px">
                <div v-for="item in checkList.slice(2)">
                    <Checkbox :label="item.value" @on-change="onCheckBoxChange($event, item.value)" :value="item.isCheck">
                        {{ $t(item.value) }}
                    </Checkbox>
                    <InputNumber v-show="item.isCheck" class="GanttSet-input" size="small" :min="1" :max="5" v-model="item.num"></InputNumber>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    declare var EDGantt: any;
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    enum ganttECT {
        ID = 1,
        Name = 2,
        StartDate = 3,
        FinishDate = 4,
        Duration = 5,
        Complete = 6,
        Resource = 7,
        Cost = 8,
        RealStartDate = 9,
        RealFinishDate = 10,
        RealDuration = 11,
        Priority = 12,
        Hyperlink = 13,
        Symbols = 14,
        CustomDate = 30,
        CustomDur = 31,
        CustomText = 32,
        CustomNum = 33,
        CustomPercent = 34,
        CustomCurrency = 35,
        Level = 36,
        Comment = 37,
        Dependency = 38,
        RightLabel = 39,
        LeftLabel = 40,
        PreColMax = 50,
    }
    @Component({
        components: {
            Dialog,
        },
    })
    export default class GanttColumnAdd extends Vue {
        checkList: any = [
            { value: "Cost", isCheck: false, num: 0, trackStr: "add Cost column" },
            { value: "Hyperlink", isCheck: false, num: 0, trackStr: "add Hyperlink column" },
            { value: "CustomText", isCheck: false, num: 0, trackStr: "add Custom Text column" },
            { value: "CustomDate", isCheck: false, num: 0, trackStr: "add Custom Date column" },
            { value: "CustomDur", isCheck: false, num: 0, trackStr: "add Duration column" },
            {
                value: "CustomCurrency",
                isCheck: false,
                num: 0,
                trackStr: "add Custom Currency column",
            },
            {
                value: "CustomPercent",
                isCheck: false,
                num: 0,
                trackStr: "add Custom Percent column",
            },
        ];
        CustomTextColumnNum: number = 1; // 自定义文本框数量

        onCheckBoxChange(isCheck, value) {
            const item = this.checkList.find((item) => item.value === value);
            item.isCheck = isCheck;
            if (item.isCheck && item.num === 0) item.num = 1;
            else if (!item.isCheck) item.num = 0;
        }

        ok() {
            let checkBoxArray: Array<any> = this.checkList.filter((item) => item.isCheck);
            let vecTypes = [];
            for (let item of checkBoxArray) {
                this.$track("rightPanel", "gantt", item.trackStr);
                vecTypes.push(...new Array(item.num).fill(item));
            }
            vecTypes = vecTypes.map((item) => ganttECT[item.value]);
            window["_view"].ganttInsertColumn(vecTypes);
            this.closeModal();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        keyboardEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }

        mounted() {}

        created() {
            document.addEventListener("keydown", this.keyboardEvent);
        }

        beforeDestroy() {
            document.removeEventListener("keydown", this.keyboardEvent);
        }

        checkCustomTextColumn() {
            // 改变工期
            // let data = parseFloat(this.$store.state.gantt.customTextColumnNum)
            // console.log("---------->>>",data)
            // window["_view"].ganttTaskOpe("RowHeight",data);
        }

        // 组件方法也可以直接声明为实例的方法
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "插入甘特图列",
    "ID": "任务ID",
    "Task Name": "任务名称",
    "Start": "开始时间",
    "Finish": "结束时间",
    "Duration": "工作日",
    "Complete": "完成",
    "Resource": "资源",
    "Cost": "费用",
    "Priority": "优先级",
    "Hyperlink": "超链接",
    "Symbols": "符号",
    "RealStartDate": "实际开始日期",
    "RealFinishDate": "实际完成日期",
    "RealDuration": "实际持续时间",
    "CustomText": "自定义文本",
    "CustomDate": "自定义日期",
    "CustomDur": "自定义持续时间",
    "CustomCurrency": "自定义货币",
    "CustomPercent": "自定义百分比",
    "CustomNumber": "自定义数字"
  },
  "en": {
    "title": "Insert Gantt Chart",
    "Start": "Start Date",
    "Finish": "Finish Date",
    "Duration": "Duration",
    "Complete": "Complete",
    "Resource": "Resource",
    "Cost": "Cost",
    "Priority": "Priority",
    "Hyperlink": "Hyperlink",
    "Symbols": "Symbols",
    "RealStartDate": "Actual Start Date",
    "RealFinishDate": "Actual Finish Date",
    "RealDuration": "Actual Duration",
    "CustomText": "Custom Text",
    "CustomDate": "Custom Date",
    "CustomDur": "Custom Duration",
    "CustomCurrency": "Custom Currency",
    "CustomPercent": "Custom Percentage",
    "CustomNumber": "Custom Number"
  },
  "jp": {
    "title": "ガントチャートを挿入",
    "Start": "開始時間",
    "Finish": "終了時間",
    "Duration": "期間",
    "Complete": "完了",
    "Resource": "リソース",
    "Cost": "費用",
    "Priority": "優先順位",
    "Hyperlink": "ハイパーリンク",
    "Symbols": "記号",
    "RealStartDate": "実際の開始日",
    "RealFinishDate": "実際の完了日",
    "RealDuration": "実際の期間",
    "CustomText": "テキストをカスタマイズ",
    "CustomDate": "日付をカスタマイズ",
    "CustomDur": "期間をカスタマイズ",
    "CustomCurrency": "通貨をカスタマイズ",
    "CustomPercent": "パーセンテージをカスタマイズ",
    "CustomNumber": "数字をカスタマイズ"
  },
  "fr": {
    "title": "Insérer un diagramme de Gantt",
    "Start": "Date de début",
    "Finish": "Date de fin",
    "Duration": "Durée",
    "Complete": "Achevé",
    "Resource": "Ressource",
    "Cost": "Coût",
    "Priority": "Priorité",
    "Hyperlink": "Hyperlien",
    "Symbols": "Symboles",
    "RealStartDate": "Date de Début Réelle",
    "RealFinishDate": "Date de Fin Réelle",
    "RealDuration": "Durée Réelle",
    "CustomText": "Texte Personnalisé",
    "CustomDate": "Date Personnalisée",
    "CustomDur": "Durée Personnalisée",
    "CustomCurrency": "Devise Personnalisée",
    "CustomPercent": "Pourcentage Personnalisé",
    "CustomNumber": "Numéro Personnalisé"
  },
  "de": {
    "title": "Gantt-Diagramm einfügen",
    "Start": "Startdatum",
    "Finish": "Enddatum",
    "Duration": "Dauerzeit",
    "Complete": "Abgeschlossen",
    "Resource": "Ressource",
    "Cost": "Kosten",
    "Priority": "Priorität",
    "Hyperlink": "Hyperlink",
    "Symbols": "Symbol",
    "RealStartDate": "Tatsächliches Startdatum",
    "RealFinishDate": "Tatsächliches Enddatum",
    "RealDuration": "Tatsächliche dauer",
    "CustomText": "Benutzerdefinierter Text",
    "CustomDate": "Benutzerdefiniertes Datum",
    "CustomDur": " Benutzerdefinierte Dauerzeit",
    "CustomCurrency": " Benutzerdefinierte Währung",
    "CustomPercent": "Benutzerdefinierte Prozente",
    "CustomNumber": "Benutzerdefinierte Nummer"
  },
  "es": {
    "title": "Insertar el gráfico de Gantt",
    "Start": "Fecha de inicio",
    "Finish": "Fecha de finalización",
    "Duration": "Duración",
    "Complete": "Completo",
    "Resource": "Recurso",
    "Cost": "Costo",
    "Priority": "Prioridad",
    "Hyperlink": "Hipervínculo",
    "Symbols": "Símbolos",
    "RealStartDate": "Fecha de inicio real",
    "RealFinishDate": "Fecha de finalización real",
    "RealDuration": "Duración real",
    "CustomText": "Texto personalizado",
    "CustomDate": "Fecha personalizada",
    "CustomDur": "Duración personalizada",
    "CustomCurrency": "Moneda personalizada",
    "CustomPercent": "Porcentaje personalizado",
    "CustomNumber": "Número personalizado"
  },
  "pt": {
    "title": "Inserir Gráfico de Gantt",
    "Start": "Data Inicial",
    "Finish": "Data Final",
    "Duration": "Duração",
    "Complete": "Completo",
    "Resource": "Recurso",
    "Cost": "Custo",
    "Priority": "Prioridade",
    "Hyperlink": "Hiperligação",
    "Symbols": "Símbolos",
    "RealStartDate": "Data Inicial Real",
    "RealFinishDate": "Data Final Real",
    "RealDuration": "Duração Real",
    "CustomText": "Texto Personalizado",
    "CustomDate": "Data Personalizada",
    "CustomDur": "Duração Personalizada",
    "CustomCurrency": "Moeda Personalizada",
    "CustomPercent": "Percentagem Personalizada",
    "CustomNumber": "Número Personalizado"
  },
  "it": {
    "title": "Inserisci Diagramma di Gantt",
    "Start": "Data di Inizio",
    "Finish": "Data di Fine",
    "Duration": "Durata",
    "Complete": "Completa",
    "Resource": "Risorse",
    "Cost": "Costi",
    "Priority": "Priorità",
    "Hyperlink": "Collegamento",
    "Symbols": "Simboli",
    "RealStartDate": "Data di Inizio Effettiva",
    "RealFinishDate": "Data di Fine Effettiva",
    "RealDuration": "Durata Effettiva",
    "CustomText": "Testo Personalizzato",
    "CustomDate": "Data Personalizzata",
    "CustomDur": "Durata Personalizzata",
    "CustomCurrency": "Valuta Personalizzata",
    "CustomPercent": "Percentuale Personalizzata",
    "CustomNumber": "Numero Personalizzato"
  },
  "tw": {
    "title": "插入甘特圖列",
    "Start": "開始時間",
    "Finish": "結束時間",
    "Duration": "持續時間",
    "Complete": "完成",
    "Resource": "資源",
    "Cost": "費用",
    "Priority": "優先級",
    "Hyperlink": "超連結",
    "Symbols": "符號",
    "RealStartDate": "實際開始日期",
    "RealFinishDate": "實際完成日期",
    "RealDuration": "實際持續日期",
    "CustomText": "自定義文本",
    "CustomDate": "自定義日期",
    "CustomDur": "自定義持續時間",
    "CustomCurrency": "自定義貨幣",
    "CustomPercent": "自定義百分比",
    "CustomNumber": "自定義數字"
  },
  "kr": {
    "title": "간트 차트 삽입",
    "Start": "시작 날짜",
    "Finish": "종료 날짜",
    "Duration": "지속 시간",
    "Complete": "완료",
    "Resource": "자원",
    "Cost": "비용",
    "Priority": "우선 순위",
    "Hyperlink": "하이퍼링크",
    "Symbols": "심볼",
    "RealStartDate": "실제 시작 날짜",
    "RealFinishDate": "실제 완료 날짜",
    "RealDuration": "실제 지속 기간",
    "CustomText": "사용자 정의 텍스트",
    "CustomDate": "사용자 정의 날짜",
    "CustomDur": "사용자 정의 지속 기간",
    "CustomCurrency": "사용자 정의 화폐",
    "CustomPercent": "사용자 정의 퍼센트",
    "CustomNumber": "사용자 정의 숫자"
  }
}
</i18n>
